import generateContext, { createAction } from '..';

export type DrawerAlignment = 'left' | 'top' | 'right' | 'bottom';
export type DrawerTypeVariant = 'permanent' | 'persistent' | 'temporary'; // Temporary is Modal View

export enum DrawerType {
  NOTIFICATION = 'Notification',
  ORDER_CARD = 'OrderCard',
  LANGUAGE_LIST = 'LanguageList',
  MOBILE_NAVIGATION = 'MobileNavigation',
  USER_PANEL = 'UserPanel',
}

export interface IDrawer {
  id: DrawerType;
  status: boolean;
}
interface IDrawerState {
  activeDrawerState: DrawerType | null;
  closeOnClick: boolean | null;
}

const initialState: IDrawerState = {
  activeDrawerState: null,
  closeOnClick: false,
};

enum InsideDrawerActionType {
  SetActiveInsideDrawer = 'SET_ACTIVE_INSIDE_DRAWER',
  SetFlushDrawer = 'SET_FLUSH_DRAWER',
}

const reducer = (
  state: IDrawerState,
  action: { type: InsideDrawerActionType; payload?: any }
): IDrawerState => {
  switch (action.type) {
    case InsideDrawerActionType.SetActiveInsideDrawer:
      return {
        ...state,
        activeDrawerState:
          state.activeDrawerState !== action.payload ? action.payload : null,
        closeOnClick: null,
      };
    case InsideDrawerActionType.SetFlushDrawer:
      return {
        ...state,
        activeDrawerState: null,
        closeOnClick: action.payload,
      };

    default:
      return state;
  }
};

const [InsideDrawerCtxProvider, useInsideDrawerState, useInsideDrawerDispatch] =
  generateContext(reducer, initialState);

const useInsideDrawerActions = () => {
  const dispatch = useInsideDrawerDispatch();

  const setActiveInsideDrawer = (payload: DrawerType | null) => {
    dispatch(
      createAction(InsideDrawerActionType.SetActiveInsideDrawer, payload)
    );
  };

  const setDrawerFlush = (payload?: boolean) => {
    dispatch(createAction(InsideDrawerActionType.SetFlushDrawer, payload));
  };

  return {
    setActiveInsideDrawer,
    setDrawerFlush,
  };
};

export {
  InsideDrawerCtxProvider,
  useInsideDrawerState,
  useInsideDrawerActions,
};
